import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';

//Función para obtener información detalles de compra Airalo
export const getPurchaseDetailsAiralo = (orderDetails) => [
  {
    label: 'Número Dalefon',
    value: orderDetails?.mobile_subscriber_dn,
  },
  {
    label: 'Fecha de compra',
    value: convertToMexicoTime(orderDetails?.created),
  },
  {
    label: 'Número de orden',
    value: orderDetails?.airalo_transaction_id,
  },
];

// Función para obtener Resumen de compra Airalo
export const getPurchaseSummaryAiralo = (orderDetails) => [
  {
    label: 'Producto',
    value: orderDetails?.package_id,
  },
  {
    label: 'Costo',
    value: orderDetails?.retail_mx_price,
  },
  {
    label: 'País o región',
    value: orderDetails?.country,
  },
  {
    label: 'Periodo de validez',
    value: orderDetails?.validity,
  },
  {
    label: 'Datos del paquete',
    value: orderDetails?.data_plan,
  },
  {
    label: 'Mensajes del paquete',
    value: orderDetails?.text,
  },
  {
    label: 'Minutos del paquete',
    value: orderDetails?.voice,
  },
  {
    label: 'Política de activación',
    value: orderDetails?.activation_policy,
  },
];

// Función para obtener información del pago de compra Airalo
export const getPurchasePaymentInformationAiralo = (orderDetails) => [
  {
    label: 'Fecha de transacción',
    value: convertToMexicoTime(orderDetails?.airalo_created_at),
  },
  {
    label: 'ID de la orden Airalo',
    value: orderDetails?.airalo_code,
  },
  {
    label: 'Estado de la orden',
    value: orderDetails?.order_status,
  },
  {
    label: 'Identificador Único',
    value: orderDetails?.payment_order_uuid,
  },
];

// Función para obtener Forma de pago de compra Airalo
export const getPurchasePaymentMethodAiralo = (orderDetails) => [
  {
    label: 'Tarjeta',
    value: orderDetails?.masked_pan,
  },
  {
    label: 'Autorización',
    value: orderDetails?.authorization_number,
  },
];

// Función para obtener Información del pagador de compra Airalo
export const getPurchasePayerInformationAiralo = (orderDetails) => [
  {
    label: 'Nombre del cliente',
    value: orderDetails?.client_name,
  },
  {
    label: 'Correo',
    value: orderDetails?.email,
  },
];

// Función para obtener Tipo de Transacción de compra Airalo
export const getPurchaseTransactionTypeAiralo = (orderDetails) => [
  {
    label: 'Concepto de pago',
    value: orderDetails?.payment_concept,
  },
  {
    label: 'Flujo',
    value: orderDetails?.application_source_name,
  },
];
